/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  block-scoped-var,
  camelcase,
  func-names,
  global-require,
  import/no-extraneous-dependencies,
  max-len,
  no-mixed-operators,
  no-redeclare,
  @typescript-eslint/no-use-before-define,
  no-var,
  one-var,
  radix,
  react/no-string-refs,
  react/prop-types,
  vars-on-top
*/
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import Button from 'common/components/button';
import classNames from 'classnames';
import HSIntlProvider from 'hellospa/components/hs-intl-provider';
import HfReactHelper from 'common/utils/hf-react-helper';
import { trackHeapCustomEvent } from 'common/utils/heap';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { getTrackingVariant } from 'common/utils/getTrackingVariant';
import pushGoogleTagManagerEvent from 'common/utils/pushGoogleTagManagerEvent';
import CreateAccount from '../auth/create-account';
import PaymentModal from './payment-modal';
import PricingLevelFeature from './pricing-level-feature';
import MailToButton from './mail-to-button';

const messages = defineMessages({
  perMonthPeriod: {
    id: '',
    description: 'label, pricing page, informs user that displayed price is per month period',
    defaultMessage: 'per month',
  },
  perYearMonthlyPrice: {
    id: '',
    description: 'label, pricing page, informs user that displayed price is per month period more explicitly',
    defaultMessage: '{price}/mo',
  },
  perYearPeriod: {
    id: '',
    description: 'label, pricing page, displays to user yearly price based on monthly price of a plan',
    defaultMessage: 'billed annually as {price}',
  },
  buttonResume: {
    id: '',
    description: 'button, pricing page, resumes subscription that was placed on hold by user',
    defaultMessage: 'Resume',
  },
  buttonUpdatePaymentInfo: {
    id: '',
    description: 'button, pricing page, will initiate flow for updating cred card info',
    defaultMessage: 'Update payment info',
  },
  buttonUnavailable: {
    id: '',
    description: 'button, pricing page, action with the button is unavailable',
    defaultMessage: 'Unavailable',
  },
  buttonEmailInquiry: {
    id: '',
    description: 'button, pricing page, initiates email sending for inquiry for other plans or custom subscriptions',
    defaultMessage: 'Alt Billing Plan Inquiry',
  },
  buttonFreeTrial: {
    id: '',
    description: 'button, pricing page, initiates free trial for subscription',
    defaultMessage: 'Start Free Trial',
  },
  buttonGetStarted: {
    id: '',
    description: 'button, pricing page, initiates flow of subscribing user onto subscription.',
    defaultMessage: 'Get Started',
  },
  modalCreateAccountHeader: {
    id: '',
    description: 'modal header, shows different UI elements to user and creates account',
    defaultMessage: 'Let\'s get started',
  },
  modalCreateAccountButton: {
    id: '',
    description: 'button, continues some initiated process',
    defaultMessage: 'Continue',
  },
});

const PricingLevel = createReactClass({

  propTypes: {
    signupUrl: PropTypes.string,
    paymentForm: PropTypes.object.isRequired, // Serialized sfForm
    signupForm: PropTypes.object.isRequired, // Serialized sfForm
    dbxPaymentMethod: PropTypes.object,
    mustContactSales: PropTypes.bool,
    isUpgrade: PropTypes.bool,
    isDelinquent: PropTypes.bool,
    changePlanRestricted: PropTypes.bool,
    googleSignInClientId: PropTypes.string,
    csrfToken: PropTypes.string,
    monthlyRedirect: PropTypes.string,
    annualRedirect: PropTypes.string,
    legalRequirementLinkHref: PropTypes.string,
    cancelLinkHref: PropTypes.string,
    countryCodeFromIp: PropTypes.string,
  },

  getInitialState() {
    return {
      expanded: false,
      isModalOpen: false,
    };
  },

  componentDidMount() {
    if (this.props.acctModalError) {
      this.launchCreateAccountModal();
    }
    if (this.props.wasSelectedBeforeLogIn) {
      this.launchPaymentModal();
    }
  },

  onLevelClick() {
    this.setState({
      expanded: !this.state.expanded,
    });
  },

  launchNoCCTrial() {
    // Submit the skip cc trial form
    this.refs[`no_cc_trial_${this.props.planId}`].submit();
  },
  closePaymentModal() {
    this.setState({ isModalOpen: false });
  },
  launchPaymentModal() {
    this.trackGAPricing();
    this.setState({ isModalOpen: true });
  },

  launchCreateAccountModal() {
    const { intl } = this.props;
    const attachPoint = HfReactHelper.getRevealAttachPoint('create_account_modal', undefined, undefined, undefined, 'close-modal-left-side');

    let redirectUrl = (this.props.timePeriod === 'M') ? this.props.monthlyRedirect : this.props.annualRedirect;

    if (this.props.monthlyExpectedRate > 0) {
      redirectUrl = `${this.props.isApi ? 'api/' : 'info/'}pricing?plan_id=${this.props.planId}&period=${this.props.timePeriod}${this.props.couponCode ? `&coupon_code=${this.props.couponCode}` : ''}`;
      if (this.props.skipCC && this.props.trialPeriod > 0) {
        redirectUrl += `&skip_cc=1&trial_period=${this.props.trialPeriod}`;
      }
      trackHeapCustomEvent('pricing_page_start_trial', { plan_id: this.props.planId });
    } else {
      // this is a free plan?
      trackHeapCustomEvent('pricing_page_get_started');
    }

    this.trackGAPricing();

    ReactDOM.render(
      (
        <HSIntlProvider>
          <CreateAccount
            key={this.props.planId}
            planId={this.props.planId}
            isApi={this.props.isApi}
            planName={this.props.rawName}
            skipCC={this.props.skipCC}
            period={this.props.timePeriod}
            trialPeriod={this.props.trialPeriod}
            googleSignInClientId={this.props.googleSignInClientId}
            csrfToken={this.props.csrfToken}
            errorMsg={this.props.acctModalError}
            header={intl.formatMessage(messages.modalCreateAccountHeader)}
            buttonText={intl.formatMessage(messages.modalCreateAccountButton)}
            isFromApiPricing={this.props.isApi}
            isFromPricing={!this.props.isApi}
            redirectUrl={redirectUrl}
            tabOffset={1000}
            signupUrl={this.props.signupUrl}
            tosUrl={this.props.tosUrl}
            privacyPolicyUrl={this.props.privacyPolicyUrl}
            countryCodeFromIp={this.props.countryCodeFromIp}
            googleAnalyticsTrackingVariant='pricing_page'
            signupForm={this.props.signupForm} />
        </HSIntlProvider>
      ),
      attachPoint,
    );
  },

  trackGAPricing() {
    let labelTag = this.props.name.toLowerCase();
    if (labelTag === 'business') {
      labelTag = 'b5';
    }

    pushGoogleTagManagerEvent({
      category: 'signup',
      action: `create account start - ${getTrackingVariant(this.props.isApi)}`,
      label: labelTag,
    });
  },

  launchSalesModal() {
    this.trackGAPricing();
    $('#contactUsButton').click();
  },

  resumeSub() {
    const plan_param = this.props.isApi ? 'api' : 'ui';
    this.trackGAPricing();
    window.location.href = `/account/revertPendingCancellation/csrf_token/${this.props.csrfToken}/plan_type/${plan_param}`;
  },

  redirectToCardUpdate() {
    this.trackGAPricing();
    window.location.href = '/account/updateCard';
  },

  render() {
    const { intl } = this.props;
    const isFree = this.props.monthlyExpectedRate <= 0;
    const bodyClasses = classNames({
      'm-pricing-level--body': true,
      'small-12': true,
      columns: true,
      expanded: this.state.expanded,
    });

    let price = '0',
      period = '',
      billingPeriod,
      priceStr = HfReactHelper.formatCurrency(intl, 0),
      approx = false,
      originalPrice = '0',
      originalPriceStr = HfReactHelper.formatCurrency(intl, 0);

    const approxStr = (
      <span>
        <FormattedMessage
          id=''
          description='part of pricing page, informs user that price for a plan that user looks at is approximate per period select (month or year)'
          defaultMessage='* approx {newLineTag}'
          values={{
            newLineTag: <br />,
          }} />
      </span>
    );

    if (!isFree) {
      if (this.props.timePeriod === 'M') {
        originalPriceStr = HfReactHelper.formatCurrency(intl, this.props.monthlyPrice);
        price = (this.props.monthlyCouponPrice ? HfReactHelper.formatCurrency(this.props.intl, this.props.monthlyCouponPrice) : originalPriceStr);
        priceStr = price;
        period = intl.formatMessage(messages.perMonthPeriod);
      } else {
        originalPrice = HfReactHelper.formatCurrency(intl, this.props.annualPrice);
        originalPriceStr = intl.formatMessage(messages.perYearMonthlyPrice, { price: originalPrice });
        price = (this.props.annualCouponPrice ? HfReactHelper.formatCurrency(this.props.intl, this.props.annualCouponPrice) : originalPrice);
        priceStr = intl.formatMessage(messages.perYearMonthlyPrice, { price });
        if ((parseFloat(price) % 1) > 0) {
          approx = true;
        }
        price = HfReactHelper.formatCurrency(intl, this.props.annualExpectedRate);
        period = intl.formatMessage(messages.perYearPeriod, { price });
      }

      billingPeriod = (
        <div className='billing-period'>
          {approx && approxStr }{!approx && period }
        </div>
      );
    } else {
      billingPeriod = (<div className='no-billing-period'></div>);
    }

    let oldPrice,
      oldPriceMobile;
    if (this.props.coupon) {

      const oldPriceMobileClasses = classNames({
        'show-for-medium-only': true,
        'small-1': true,
        'medium-3': true,
        columns: true,
        'level-price': true,
        'l-padding-t-35': true,
      });

      if (this.props.couponEligible) {
        oldPrice = (
          <div className='m-pricing-level--body small-4 large-12 small-centered columns level-price'>
            <div className='price crossed'>{originalPriceStr}</div>
          </div>
        );

        oldPriceMobile = (
          <div className={oldPriceMobileClasses}>
            <span className='price crossed'>{originalPriceStr}</span>
          </div>
        );
      } else {
        oldPrice = (
          <div className='m-pricing-level--body small-4 large-12 small-centered columns level-price l-padding-t-50'>
          </div>
        );

        oldPriceMobile = (
          <div className={oldPriceMobileClasses}>
          </div>
        );
      }
    }

    // Get started button logic
    let getStarted;

    let primaryColor = 'cerulean';
    let primaryColorBG = 'bgi-cerulean';
    if (!HfReactHelper.isHelloSign()) {
      primaryColor = 'goldenrod';
      primaryColorBG = 'bgi-goldenrod';
    }

    if (this.props.isCurrentPlan && !this.props.isDelinquent
      && ((!this.props.isApi) && this.props.UiPendingCancel
        || (this.props.isApi) && this.props.ApiPendingCancel
      ) && this.props.isAdmin) {
      const buttonText = intl.formatMessage(messages.buttonResume);
      let buttonFunc = this.resumeSub;
      const autoRenewalPlans = ['Essentials', 'Home Office', 'Professional'];
      if (autoRenewalPlans.includes(this.props.rawName)) {
        buttonFunc = this.launchPaymentModal;
      }
      getStarted = (
        <Button
          buttonText={buttonText}
          onClick={buttonFunc}
          buttonHoverColor={primaryColor}
          buttonBorderRounded={true}
        >
        </Button>);
      // Special cases for delinquent subscriptions
    } else if (this.props.isDelinquent && !this.props.changePlanRestricted) {
      let buttonText,
        buttonColor,
        buttonHoverColor,
        buttonFunc;
      // Allow access to CC update only on current plan
      if (this.props.isCurrentPlan) {
        buttonText = intl.formatMessage(messages.buttonUpdatePaymentInfo);
        buttonFunc = this.redirectToCardUpdate;
        buttonColor = 'ashen';
        buttonHoverColor = primaryColor;
        // Disallow plan change
      } else {
        buttonText = intl.formatMessage(messages.buttonUnavailable);
        buttonFunc = function () {}; // noop
        buttonColor = 'cinder-block';
        buttonHoverColor = 'cinder-block';
      }
      getStarted = (
        <Button
          buttonText={buttonText}
          onClick={buttonFunc}
          buttonColor={buttonColor}
          buttonHoverColor={buttonHoverColor}
          buttonBorderRounded={true}
        >
        </Button>
      );
    } else if (this.props.isCurrentPlan) {
      getStarted = (
        <div className='current-plan'>
          <FormattedMessage
            id=''
            description='button, pricing page, button is locked, and informs user that plan is already active'
            defaultMessage='You are currently on this plan' />
        </div>
      );
    } else if (this.props.changePlanRestricted) {
      const supportEmail = HfReactHelper.HfConstants.supportEmail[HfReactHelper.HfSites.SITE_CODE_HS];
      getStarted = (
        <MailToButton
          email={supportEmail}
          subject={intl.formatMessage(messages.buttonEmailInquiry)} />
      );
    } else if (this.props.isAdmin
      && (!this.props.isApi
        && !this.props.UiPendingCancel
        || this.props.isApi
        && !this.props.ApiPendingCancel
      )) {
      const isSkipCC = this.props.isLoggedIn && this.props.skipCC && this.props.trialPeriod > 0;
      let buttonText = intl.formatMessage(messages.buttonFreeTrial);
      let buttonFunc = isSkipCC ? this.launchNoCCTrial : this.launchCreateAccountModal;

      if (this.props.isLoggedIn && !isSkipCC) {
        buttonFunc = this.launchPaymentModal;
      }
      if (this.props.mustContactSales && this.props.isUpgrade) {
        buttonFunc = this.launchSalesModal;
      }

      if (this.props.isApi || isFree || (this.props.isLoggedIn && !this.props.isFreeTrialEligible)) {
        buttonText = intl.formatMessage(messages.buttonGetStarted);
      }
      getStarted = (
        <Button
          data-qa-ref={`plan-${this.props.planId}`}
          buttonText={buttonText}
          onClick={buttonFunc}
          buttonHoverColor={primaryColor}
          buttonBorderRounded={true}
        >
        </Button>); // FIXME: test
    } else {
      getStarted = (<div className='no-plan-option' />);
    }

    // No CC Free trial form
    let noCCTrialForm;
    if (this.props.isLoggedIn && this.props.skipCC && !isFree && this.props.trialPeriod > 0) {
      noCCTrialForm = (
        <form action="" method="POST" id={`no_cc_trial_${this.props.planId}`} ref={`no_cc_trial_${this.props.planId}`}>
          <input type="hidden" name="skip_free_trial_cc" value="1" />
          <input type="hidden" name="period" value={this.props.timePeriod} />
          <input type="hidden" name="free_trial_period" value={this.props.trialPeriod} />
          <input type="hidden" name="plan_id" value={this.props.planId} />
        </form>
      );
    }

    let mainFeature;
    if (this.props.mainFeature) {
      const name = (this.props.mainFeature.name ? this.props.mainFeature.name : name);
      const detail = (this.props.mainFeature.detail ? this.props.mainFeature.detail : null);
      const number = (this.props.mainFeature.number ? this.props.mainFeature.number : null);
      mainFeature = (
        <PricingLevelFeature
          name={name}
          planName={this.props.name}
          detail={detail}
          number={number}
          isFree={isFree}
          key={'T%'}
          expanded={this.state.expanded}
        >
        </PricingLevelFeature>);
    }

    const features = this.props.features.map((feature, i) => {
      const name = (feature.name ? feature.name : name);
      const detail = (feature.detail ? feature.detail : null);
      const number = (feature.number ? feature.number : null);
      return (
        <PricingLevelFeature
          name={name}
          planName={this.props.name}
          detail={detail}
          number={number}
          key={`feature${i}`}
          isFree={isFree}
          expanded={this.state.expanded}
        >
        </PricingLevelFeature>
      );
    });

    const name = this.props.name;

    const levelClasses = classNames({
      'small-5': true,
      'medium-4': !this.props.coupon,
      'medium-offset-1': true,
      'medium-3': this.props.coupon,
      'large-12': true,
      'large-offset-0': true,
      columns: true,
      'level-title': true,
    });
    const arrowClasses = classNames({
      'l-vertical-align': true,
      arrow: true,
      expanded: this.state.expanded,
    });

    const priceClasses = classNames({
      price: true,
    });

    return (
      <div data-test-id='pricing-level' className={classNames({
        'm-pricing-level': true,
        'small-12': true,
        'medium-12': true,
        'large-3': !HfReactHelper.isHelloSign() && this.props.totalColumns >= 3,
        'large-4': HfReactHelper.isHelloSign() && this.props.totalColumns >= 3,
        'large-6': this.props.totalColumns === 2,
        'large-12': this.props.totalColumns === 1,
        columns: true,
      })}
      >
        <div onClick={this.onLevelClick} className={classNames(primaryColorBG, {
          'm-pricing-level--header': true,
          'small-12': true,
          'medium-12': true,
          columns: true,
          block: true,
        })}
        >
          <div className={levelClasses}>
            <div className='level-title l-vertical-align-wrapper'>
              <div className='l-vertical-align'>{ name ? name.toLocaleUpperCase(intl.locale) : '' }</div>
            </div>
          </div>
          { oldPriceMobile }
          <div className={classNames({
            'hide-for-large-up': true,
            'small-7': true,
            'medium-5': true,
            'medium-offset-0': this.props.coupon,
            'medium-offset-1': !this.props.coupon,
            columns: true,
            'level-price': true,
          })}
          >
            <div className='level-title l-vertical-align-wrapper'>
              <div className='l-vertical-align'>
                <span className={priceClasses}>{ priceStr }
                  <span className='billing-period'>{ period }</span>
                </span>
              </div>
            </div>
          </div>
          <div className={classNames({
            'arrow-container': true,
            'hide-for-large-up': true,
            'hide-for-small': true,
            'small-2': true,
            'medium-1': true,
            columns: true,
          })}
          >
            <div className='level-title l-vertical-align-wrapper'>
              <div className={arrowClasses}>&nbsp;</div>
            </div>
          </div>
        </div>
        <div className={bodyClasses}>
          <div className='first-section block'>
            { oldPrice }
            <div className='m-pricing-level--body small-3 large-12 small-centered columns block'>
              <div className={priceClasses}>{ priceStr }</div>
              { billingPeriod }
            </div>
            <div className='block'>
              { getStarted }
              <PaymentModal
                key={this.props.planId}
                isUpgrade={this.props.isUpgrade}
                planId={this.props.planId}
                planName={this.props.name}
                planRawName={this.props.rawName}
                isFreeTrialEligible={this.props.isFreeTrialEligible}
                isApi={this.props.isApi}
                numFreeDays={this.props.numFreeDays}
                price={this.props.price}
                timePeriod={this.props.timePeriod}
                monthlyExpectedRate={this.props.monthlyExpectedRate}
                annualExpectedRate={this.props.annualExpectedRate}
                monthlyCouponPrice={this.props.monthlyCouponPrice}
                annualCouponPrice={this.props.annualCouponPrice}
                monthlyProratedRate={this.props.monthlyProratedRate}
                annualProratedRate={this.props.annualProratedRate}
                currentMonthlyRate={this.props.currentMonthlyRate}
                currentAnnualRate={this.props.currentAnnualRate}
                isTrialing={this.props.isTrialing}
                proratio={this.props.proratio}
                monthPrice={this.props.monthlyPrice}
                annualPrice={this.props.annualPrice * 12}
                couponCode={this.props.couponCode}
                couponNumMonths={this.props.couponNumMonths}
                ccSuffix={this.props.ccSuffix}
                ccExpiration={this.props.ccExpiration}
                cardHolderName={this.props.cardHolderName ? this.props.cardHolderName : ''}
                name={this.props.name}
                paymentForm={this.props.paymentForm}
                registerFaxLineForm={this.props.registerFaxLineForm}
                csrfToken={this.props.csrfToken}
                dbxPaymentMethod={this.props.dbxPaymentMethod}
                errors={this.props.errors}
                currentPlanName={this.props.currentPlanName}
                tosUrl={this.props.tosUrl}
                refundPolicyUrl={this.props.refundPolicyUrl}
                privacyPolicyUrl={this.props.privacyPolicyUrl}
                ackAutoRenewal={this.props.ackAutoRenewal}
                showHSAutoRenewal={this.props.showHSAutoRenewal}
                isAccountConfirmed={this.props.isAccountConfirmed}
                UiPendingCancel={this.props.UiPendingCancel}
                isModalOpen={this.state.isModalOpen}
                closeModal={this.closePaymentModal}
                legalRequirementLinkHref={this.props.legalRequirementLinkHref}
                cancelLinkHref={this.props.cancelLinkHref}
                nextBillingDate={this.props.nextBillingDate}
                newNumFaxPages={this.props.newNumFaxPages}
                newPageQuota={this.props.newPageQuota}
                numPagesUsed={this.props.numPagesUsed}
                faxLinesCostInCents={this.props.faxLinesCostInCents}
                hasTeam={this.props.hasTeam} />
              { noCCTrialForm }
            </div>
            { mainFeature }
          </div>
        </div>
        { features }
      </div>
    );
  },
});

module.exports = injectIntl(PricingLevel);
